import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import "./index.css";
import "./assets/css/json-dialog.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store, persistor } from "./store";
import TagManager from "react-gtm-module";

// Normalize any double slashes in the pathname (e.g. from email templates with //reset-password)
if (typeof window !== "undefined" && window.location.pathname.includes("//")) {
  const normalizedPath = window.location.pathname.replace(/\/+/g, "/");
  window.history.replaceState(
    null,
    "",
    normalizedPath + window.location.search + window.location.hash
  );
}

const googleTagKey = process.env.REACT_APP_GOOGLE_TAG_KEY;

if (googleTagKey) {
  if (googleTagKey.startsWith("G-")) {
    // Google Analytics 4 (gtag.js)
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${googleTagKey}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", googleTagKey);
  } else {
    // Google Tag Manager container (GTM-XXXXX)
    TagManager.initialize({ gtmId: googleTagKey });
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    </PersistGate>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
